import { useContext, memo } from "react";
import { Context } from "../Provider";

const NotificationMessages = memo(({ color, override = null }) => {
    const { identificationDetails } = useContext(Context);
    const step = identificationDetails?.last_approval_process_step?.ftm_approval_process_step;

    if (!step) return null;

    const { ftm_approval_process_step_icon: icon, ftm_approval_process_step_message: message } = step;

    return (
        <div className="card shadow-none mb-3">
            <div className="card-body p-3 d-flex align-items-center">
                <span className={`material-icons text-lg me-2 text-${color || 'secondary'}`}>
                    {icon}
                </span>
                <b>{override || message}</b>
            </div>
        </div>
    );
});

export default NotificationMessages;